export default __webpack_public_path__ + "static/media/quansight.a99b6193.png";